import Skeleton from "react-loading-skeleton";

import * as theme from "./theme.css";

interface EditableTagListInputSkeletonProps {
    count?: number;
}
export const EditableTagListInputSkeleton = ({
    count = 5,
}: EditableTagListInputSkeletonProps) => {
    const countInclButton = count + 1;
    return (
        <div className={theme.tagsContainer}>
            {Array.from({ length: countInclButton }).map((_item, index) => (
                <Skeleton
                    key={index}
                    className={theme.editableTagListSkeleton}
                />
            ))}
        </div>
    );
};
